import { RADIUS_LG } from '@mnd-frontend/ui';

export const EMPTY_ARRAY = Object.freeze([]) as [];

export const STATES = {
  PENDING: 'PENDING', // Action has not yet been received.
  LOADING: 'LOADING', // Action has been triggered but has not reached a final state.
  SUCCESS: 'SUCCESS', // Action has completed and was successful.
  FAILURE: 'FAILURE', // Action was completed but was not successful.
  DELAYED: 'DELAYED', // Action was not successful but will retry again.
  PREVENT: 'PREVENT', // Action was prevented from completing.
  REQUEST: 'REQUEST', // Action has been requested.
  CANCELED: 'CANCELED', // Action has been cancelled.
} as const;

export const HTTP_OR_HTTPS_PREFIX_REGEX = /^http(s)?:\/\//;

export const QUERY_PARAM_WHICH_INDICATES_INITIALLY_OPENED_MODAL = 'openContactPersonModal';
export const OPENED_CONTACT_PERSON_FORM_FROM_MATERIAL_QUERY_PARAM = 'materialConnection';
export const OPENED_CONTACT_PERSON_FORM_FROM_MATERIAL_CHECK_DRAFT_QUERY_PARAM = 'isDraft';
export const QUERY_PARAM_FOR_PREFILLED_TAG_SEARCH = 'tagName';
export const SITE_CONTENT_RADIUS = RADIUS_LG;
